// eslint-disable-next-line import/no-anonymous-default-export
export default {
  formId: "OutputSubmission",
  formField: {
    statementReportGuideline: {
      name: "statementReportGuideline",
      label: "Have you read entire statement in report guideline? *",
      requiredErrorMsg: "Report guideline is required"
    },
    howManyPublicationSubmitC2FReport: {
      name: "howManyPublicationSubmitC2FReport",
      label: "How many publication you want to submit to C2F in this report? *",
      requiredErrorMsg: "Publication submit is required"
    },
    yourResearchField: {
      name: "yourResearchField",
      label: "Your Research Field *",
      requiredErrorMsg: "Research field is required"
    },
    publicationEvidence: {
      name: "publicationEvidence",
      subMenu: [
        {
          journalRanking: {
            name: "journalRanking",
            label: "Journal Ranking * ",
            requiredErrorMsg: "Journal Ranking is required"
          },
          publicationStatus: {
            name: "publicationStatus",
            label: "Publication Status * ",
            requiredErrorMsg: "Publication Status is required"
          },
          typeResearchPublication: {
            name: "typeResearchPublication",
            label: "Type of research publication *",
            requiredErrorMsg: "Type of research publication is required"
          },
          acceptedDate: {
            name: "acceptedDate",
            label: "Accepted date *",
            requiredErrorMsg: "Accepted date is required"
          },
          publishedDate: {
            name: "publishedDate",
            label: "Published date *",
            requiredErrorMsg: "Published date is required"
          },
          doi: {
            name: "doi",
            label: "DOI *",
            requiredErrorMsg: "DOI is required"
          },
          uploadResearchPublication: {
            name: "uploadResearchPublication",
            label: "Please upload your research publication *",
            requiredErrorMsg: " Research publication is required",
            file: {}
          },
          articleTitle: {
            name: "articleTitle",
            label: "Article Title *",
            requiredErrorMsg: "Article title is required"
          },
          journalName: {
            name: "journalName",
            label: "Journal's Name *",
            requiredErrorMsg: "Journal's Name is required"
          },
          subjectAreaCategory: {
            name: "subjectAreaCategory",
            label: "Subject Area and Category *",
            requiredErrorMsg: "Subject Area and Category is required"
          },
          journalRankingPercentagePercentile: {
            name: "journalRankingPercentagePercentile",
            label: "Journal Ranking Percentage or Percentile *",
            requiredErrorMsg: "Percentage or Percentile is required"
          },
          screenshotJournalRankingEvidence: {
            name: "screenshotJournalRankingEvidence",
            label: "Screenshot of Journal Ranking Evidence *",
            requiredErrorMsg: "Journal Ranking Evidence is required",
            file: {}
          },
          firstAuthor: {
            name: "firstAuthor",
            label: "First Author *",
            requiredErrorMsg: "First Author is required"
          },
          correspondingAuthor: {
            name: "correspondingAuthor",
            label: "Corresponding Author *",
            requiredErrorMsg: "Corresponding Author is required"
          },
          collaboratorFromTop100: {
            name: "collaboratorFromTop100",
            label: `Do you have "Collaborator(s)" from Top 100 University Ranking/ Subject Ranking or Top Institute or High Performance Professor as "Co-Author" or else? *`,
            requiredErrorMsg: "Collaborator is required"
          },
          collaboratorName: {
            name: "collaboratorName",
            label: `Collaborator Name *`,
            requiredErrorMsg: "Collaborator name is required"
          },
          universityInstituteCollaborator: {
            name: "universityInstituteCollaborator",
            label: `University/Institute of Collaborator*`,
            requiredErrorMsg: "University/Institute of Collaborator is required"
          },
          referenceWorldRankingStatus: {
            name: "referenceWorldRankingStatus",
            label: `Reference of World Ranking Status *`,
            requiredErrorMsg: "Reference of World Ranking Status is required"
          },
          worldRankingYear: {
            name: "worldRankingYear",
            label: `World Ranking Year *`,
            requiredErrorMsg: "World Ranking Year is required"
          },
          noWorldRanking: {
            name: "noWorldRanking",
            label: `No. of World Ranking *`,
            requiredErrorMsg: "No. of World Ranking is required"
          },
          evidenceTopInternationalInstitute: {
            name: "evidenceTopInternationalInstitute",
            label: `Evidence of Top International Institute *`,
            requiredErrorMsg: "International Institute is required",
            file: {}
          },
          evidenceHighPerformanceProfessor: {
            name: "evidenceHighPerformanceProfessor",
            label: `Evidence of High Performance Professor *`,
            requiredErrorMsg: "Performance Professor is required",
            file: {}
          }
        }
      ]
    }
  }
};
